import {SEGMENTED_PUSH} from '../actions/const';

import moment from 'moment';

const initialState = {
  userType: {value: 'all', label: 'ALL'},
  userTypeOptions: [
		{
			value: 'all',
			label: 'ALL'
		}, {
			value: 'member',
			label: 'MEMBER'
		}, {
			value: 'non-member',
			label: 'NON-MEMBER'
		}
	],
  ageBracket: [35, 45],
  deviceType: {value: 'all', label: 'ALL'},
  deviceTypeOptions: [
    {
			value: 'all',
			label: 'ALL'
		}, {
			value: 'android',
			label: 'ANDROID'
		}, {
			value: 'ios',
			label: 'IOS'
		}
  ],
  gender: {value: 'all', label: 'ALL'},
  genderOptions: [
    {
      value: 'all',
      label: 'All'
    }, {
      value: 'male',
      label: 'Male'
    }, {
      value: 'female',
      label: 'Female'
    }
  ],
  segmentType: null,
  isSendNow: true,
  pushNotificationSchedule: moment(),
  limit: 10,
  tableData: [],
  totalRecord: ''
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case SEGMENTED_PUSH:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/SegmentedPush.js